import { User } from '../types';

const INTERCOM_APP_ID = 'naceb5cx'; // Same as used in react project

const trackers = {
  intercom: {
    boot: (user?: User) => {
      try {
        /* eslint-disable */
        (function () {
          var w = window as any;
          var ic = w.Intercom;
          if (typeof ic === 'function') {
            ic('reattach_activator');
            ic('update', w.intercomSettings);
          } else {
            var d = document;
            var i = function () {
              (i as any).c(arguments);
            } as any;
            i.q = [];
            i.c = function (args: any) {
              i.q.push(args);
            };
            w.Intercom = i;
            var l = function() {
              var s = d.createElement('script');
              s.crossOrigin = 'anonymous';
              s.type = 'text/javascript';
              s.async = true;
              s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
              var x = d.getElementsByTagName('script')[0];
              if (x && x.parentNode) {
                x.parentNode.insertBefore(s, x);
              } else {
                // Fallback if no scripts found
                document.head.appendChild(s);
              }
            };
            // Check if document is already loaded
            if (document.readyState === 'complete' || document.readyState === 'interactive') {
              // Document already loaded, run immediately
              l();
            } else {
              // Wait for window load
              if (w.attachEvent) {
                w.attachEvent('onload', l);
              } else {
                w.addEventListener('load', l, false);
              }
            }
          }
        })();
        /* eslint-enable */
        
        if (user) {
          let userCreatedAt = Math.floor(new Date().getTime() / 1000);
          if (user.createdAt) {
            const parsedDate = new Date(user.createdAt).getTime();
            if (!isNaN(parsedDate)) {
              userCreatedAt = Math.floor(parsedDate / 1000);
            }
          }
          
          const intercomSettings = {
            app_id: INTERCOM_APP_ID,
            name: user.name || `${user.firstname} ${user.lastname}`.trim() || user.email,
            email: user.email,
            user_id: user.id,
            created_at: userCreatedAt,
            hide_default_launcher: false,  // Explicitly show the launcher
            custom_attributes: {
              mfa_enabled: user.mfaEnabled,
              is_support_admin: user.isSupportAdmin,
              environment: process.env.NODE_ENV,
              app: 'scrtracker-web',
            },
          };
          
          (window as any).Intercom('boot', intercomSettings);
        } else {
          (window as any).Intercom('boot', { app_id: INTERCOM_APP_ID });
        }
      } catch (e) {
        console.error('Could not boot Intercom:', e);
      }
    },
    
    update: (user?: User) => {
      try {
        if (user) {
          (window as any).Intercom('update', { 
            email: user.email,
            name: user.name || `${user.firstname} ${user.lastname}`.trim(),
          });
        }
      } catch (e) {
        console.error('Could not update Intercom:', e);
      }
    },
    
    shutdown: () => {
      try {
        if (typeof (window as any).Intercom === 'function') {
          (window as any).Intercom('shutdown');
        } else {
          console.warn('Intercom not initialized, skipping shutdown');
        }
      } catch (e) {
        console.error('Could not shutdown Intercom:', e);
      }
    },
    
    track: (eventName: string, metadata?: Record<string, any>) => {
      try {
        (window as any).Intercom('trackEvent', eventName, metadata);
      } catch (e) {
        console.error('Could not track event in Intercom:', e);
      }
    },
  },
};

export const start = (user?: User) => {
  trackers.intercom.boot(user);
};

export const update = (user?: User) => {
  trackers.intercom.update(user);
};

export const shutdown = () => {
  trackers.intercom.shutdown();
};

export const track = (eventName: string, metadata?: Record<string, any>) => {
  trackers.intercom.track(eventName, metadata);
};

export default {
  start,
  update,
  shutdown,
  track,
  ...trackers,
};